import { Injectable } from '@angular/core';
import { DialogMode } from '@core/model/appeals-and-grievances-widget';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AppealsAndGrievancesInformationService<T = undefined> {
  private readonly data = new BehaviorSubject<T>(null);
  private readonly dialogMode: BehaviorSubject<DialogMode | null> = new BehaviorSubject(null);

  readonly data$ = this.data.asObservable();
  readonly dialogMode$ = this.dialogMode.asObservable();

  saveData(data: T) {
    this.data.next(data);
  }

  setDialogMode(mode: DialogMode | null) {
    this.dialogMode.next(mode);
  }
}
